import slugify from 'slugify'

/**
 * Concatenates the given parts, turns them into a slug and returns them.
 */
export function dataTest(...parts: string[]) {
    return slugify(parts.join(`-`), { lower: true, strict: true, })
}

